/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GameType from './GameType';

/**
 * The CampaignControllerDtoCampaignListRequest model module.
 * @module model/CampaignControllerDtoCampaignListRequest
 * @version 1.0
 */
class CampaignControllerDtoCampaignListRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoCampaignListRequest</code>.
     * @alias module:model/CampaignControllerDtoCampaignListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        CampaignControllerDtoCampaignListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>CampaignControllerDtoCampaignListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoCampaignListRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoCampaignListRequest} The populated <code>CampaignControllerDtoCampaignListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoCampaignListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('campaignType')) {
                obj['campaignType'] = GameType.constructFromObject(data['campaignType']);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('includePendingCampaigns')) {
                obj['includePendingCampaigns'] = ApiClient.convertToType(data['includePendingCampaigns'], 'Boolean');
            }
            if (data.hasOwnProperty('searchString')) {
                obj['searchString'] = ApiClient.convertToType(data['searchString'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoCampaignListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoCampaignListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoCampaignListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['searchString'] && !(typeof data['searchString'] === 'string' || data['searchString'] instanceof String)) {
            throw new Error("Expected the field `searchString` to be a primitive type in the JSON string but got " + data['searchString']);
        }

        return true;
    }


}

CampaignControllerDtoCampaignListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
CampaignControllerDtoCampaignListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
CampaignControllerDtoCampaignListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
CampaignControllerDtoCampaignListRequest.prototype['skip'] = undefined;

/**
 * @member {module:model/GameType} campaignType
 */
CampaignControllerDtoCampaignListRequest.prototype['campaignType'] = undefined;

/**
 * @member {Number} status
 */
CampaignControllerDtoCampaignListRequest.prototype['status'] = undefined;

/**
 * @member {Boolean} includePendingCampaigns
 */
CampaignControllerDtoCampaignListRequest.prototype['includePendingCampaigns'] = undefined;

/**
 * @member {String} searchString
 */
CampaignControllerDtoCampaignListRequest.prototype['searchString'] = undefined;






export default CampaignControllerDtoCampaignListRequest;

